import moment from "moment"

export const YEAR = moment.duration(1, `y`).asMilliseconds()
export const QUARTER = moment.duration(3, `M`).asMilliseconds()
export const MONTH = moment.duration(1, `M`).asMilliseconds()
export const WEEK = moment.duration(1, `w`).asMilliseconds()
export const DAY = moment.duration(1, `d`).asMilliseconds()

export const DEFAULT_PAGE_HEIGHT = 30 // rows

export const DEFAULT_SCALE = DAY
export const DEFAULT_DATE_FORMAT = `DD.MM.YYYY`

export const EVENT_ABSOLUTE_MIN_DURATION = moment
  .duration(1, `minute`)
  .asMilliseconds()

export const ALL_SCALES = [
  DAY,
  WEEK,
  MONTH,
  // QUARTER,
  YEAR,
]

export const USER_SCALES = [
  DAY,
  WEEK,
  MONTH,
  // QUARTER,
  YEAR,
]
export const SCALE_NAMES = {
  [DAY]: `День`,
  [WEEK]: `Неделя`,
  [MONTH]: `Месяц`,
  // [QUARTER]  : `Квартал`,
  [YEAR]: `Год`,
}
export const CHIPS_SCALE_NAMES = {
  [DAY]: `1д`,
  [WEEK]: `1н`,
  [MONTH]: `1м`,
  [YEAR]: `1г`,
}
export const RC_CALENDAR_MODE_NAMES = {
  [DAY]: `date`,
  [WEEK]: `week`,
  [MONTH]: `month`,
  [YEAR]: `year`,
}
export const TODAY_START = moment()
  .startOf(`day`)
  .valueOf()
export const TODAY_END = moment()
  .endOf(`day`)
  .valueOf()
export const SCALE_CODES = {
  [DAY]: `day`,
  [WEEK]: `week`,
  [MONTH]: `month`,
  // [QUARTER]  : `quarter`,
  [YEAR]: `year`,
}
export const SCALE_FROM_CODE = {
  day: DAY,
  week: WEEK,
  month: MONTH,
  year: YEAR,
}
export const SCALE_FORMAT_MASKS = {
  [DAY]: `dddd, D MMMM YYYY`,
  [WEEK]: `D MMM YYYY`,
  [MONTH]: `MMMM YYYY`,
  // [QUARTER]  : `YYYY`,
  [YEAR]: `YYYY`,
}
export const SCALE_TIMESTEPS = {
  [DAY]: {
    second: 0,
    minute: 0,
    hour: 1,
    day: 1,
    month: 1,
    year: 1,
  },
  [WEEK]: {
    second: 0,
    minute: 0,
    hour: 0,
    day: 1,
    month: 1,
    year: 1,
  },
  [MONTH]: {
    second: 0,
    minute: 0,
    hour: 0,
    day: 1,
    month: 1,
    year: 1,
  },
  [YEAR]: {
    second: 0,
    minute: 0,
    hour: 0,
    day: 0,
    month: 1,
    year: 1,
  },
}

export const SCALE_ZOOMS = {
  [DAY]: {
    min: 1000 * 60 * 60, // 1 hour
    max: DAY - 1,
  },
  [WEEK]: {
    min: DAY,
    max: WEEK - 1,
  },
  [MONTH]: {
    min: WEEK,
    max: MONTH - 1, // Will be overriden by getMaxZoom() when set to calendar timeline because of variable months length
  },
  [YEAR]: {
    min: MONTH,
    max: YEAR - 1,
  },
}

export const SCALE_ARROW_TOOLTIP = {
  day: {
    forward: `Следующий день`,
    back: `Предыдущий день`,
  },
  week: {
    forward: `Следующая неделя`,
    back: `Предыдущая неделя`,
  },
  month: {
    forward: `Следующий месяц`,
    back: `Предыдущий месяц`,
  },
  year: {
    forward: `Следующий год`,
    back: `Предыдущий год`,
  },
}

export const URL_DATE_FORMAT = `DD-MM-YYYY`

// Local storage keys for calendar data
export const LAST_SELECTED_DATES = `lastSelectedDates`
export const LAST_SCROLL_POSITIONS = `lastScrollPositions`

// Local storage key for event creation form
export const EVENT_CREATION_INITIAL_PARAMS = `eventCreationInitialParams`

export const BLANK_ITEM_ID = `system-blank-item`

export const DEFAULT_EVENT_OPACITY = 0.3

export const LAYER_HEIGHT = 56
export const GROUPS_HIDING_THROTTLE_DELAY = 200
export const GROUPS_HIDING_ADDITIONAL_PAGES = 2
